import { OrderStatusBadge } from '@/components/order-status-badge'
import ProductDetail from '@/components/product-detail'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { DataTable } from '@/components/ui/data-table'
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog'
import { filterApi } from '@/queries/search'
import type { OrderStatus } from '@/types'
import { useQuery } from '@tanstack/react-query'
import { Link, createFileRoute } from '@tanstack/react-router'
import { Box } from 'lucide-react'
import { useState } from 'react'

export const Route = createFileRoute('/shop/orders/')({
  component: ShopOrders,
})

function ShopOrders() {
  const [detail, setDetail] = useState<{modal:boolean, products?: Array<{id:number,name: string, pivot: {quantity: number, price: number}}>}>({modal: false, products: []})
  const ordersListQuery = useQuery({
    queryFn: () => filterApi('order', {products: 'products', store:'cart'}),
    queryKey: ['orderList'],
  })

  const columns = [
    {
      header: 'شماره سفارش',
      accessorKey: 'id',
    },
    {
      header: 'وضعیت',
      accessorKey: 'status',
      cell: ({getValue}: {getValue: () => keyof typeof OrderStatus}) => {

        return <>
          <OrderStatusBadge status={getValue()}/>
        </>
      }
    },
    {
      header: 'مبلغ',
      accessorKey: 'price',
      cell: ({getValue}: any) => {
        return Intl.NumberFormat().format(getValue()) + ' ریال'
      }
    },
    {
      header: 'تخفیف',
      accessorKey: 'total_discount',
      cell: ({getValue}: any) => {
        return Intl.NumberFormat().format(getValue()) + ' ریال'
      }
    },
    {
      header: 'هزینه ارسال',
      accessorKey: 'delivery_price',
      cell: ({getValue}: any) => {
        return Intl.NumberFormat().format(getValue()) + ' ریال'
      }
    },
    {
      header: 'مجموع مبلغ',
      accessorKey: 'final_price',
      cell: ({getValue}: any) => {
        return Intl.NumberFormat().format(getValue()) + ' ریال'
      }
    },
    {
      header: '',
      id: 'action',
      cell: ({row}: {row: {original: any}}) => {
        return <>
          <Button onClick={() => setDetail({modal: true, products: row.original.products})}>
            <Box className='ml-2'/>
            محصولات
          </Button>
        </>
      }
    }

  ]

  return (<>
  <Dialog open={detail.modal} onOpenChange={(open) => setDetail(d => ({...d, modal:open}))}>
    <DialogContent>
      <DialogHeader>
        <DialogTitle>جزئیات سفارش</DialogTitle>
      </DialogHeader>
      {detail.products && <div className='grid grid-cols-3'>
        {detail.products.map(pr => <>
            <ProductDetail key={pr.id} product={pr}/>
        </>)}
      </div>}
      <DialogFooter>
        <Button variant="secondary" onClick={() => setDetail({modal: false, products: []})}>بستن</Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
  <Card>
    <CardHeader className='flex-row justify-between items-center'>
      <CardTitle>
        سفارشات شما
      </CardTitle>

      <Link to="/shop">
        <Button>
          بازگشت به فروشگاه
        </Button>
      </Link>
    </CardHeader>

    <CardContent>
      <DataTable<any , any> columns={columns} data={ordersListQuery.data?.data?.data || []} pageCount={ordersListQuery?.data?.data?.meta?.last_page}/>
    </CardContent>
  </Card>
  </>)
}
